import React from 'react'
import { Password } from '../Password'
import { ConfirmPassword } from '../ConfirmPassword'
import { Header } from '../../Header'
import { Separator } from '../Separator'
import config from 'SRC/config/config.yaml'

export const Container = () => [
  <Header key='header'>{config.updateProfileForm.password.changePassword}</Header>,
  <div className='form-sifra' key='password'>
    <Password />
    <ConfirmPassword />
  </div>,
  <Separator key='separator' />
]

Container.displayName = 'ChangePassword'
